/**
 * Hook zum Laden der Projekt-Geometrie (Windpark-Fläche).
 * Schlanke Alternative zu useAreaData — lädt nur Geometrie und Standort-Koordinate,
 * ohne Auto-Save, Beschreibung oder andere Area-Felder.
 */
import { useState, useEffect, useCallback } from "react";
import { areasApi } from "../../../services/api/areas";
import { GeoJSON } from "../../../types";

interface StandortKoordinate {
  breitengrad: number;
  laengengrad: number;
}

export function useProjectGeometrie(projectId: string | undefined) {
  const [geometrie, setGeometrie] = useState<GeoJSON | undefined>();
  const [areaId, setAreaId] = useState<string | undefined>();
  const [standortKoordinate, setStandortKoordinate] = useState<
    StandortKoordinate | undefined
  >();
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    if (!projectId) return;
    setLoading(true);
    try {
      const area = await areasApi.getProjectArea(projectId);
      setGeometrie(area?.geometrie);
      setAreaId(area?.id);
      setStandortKoordinate(
        area?.breitengrad != null && area?.laengengrad != null
          ? { breitengrad: area.breitengrad, laengengrad: area.laengengrad }
          : undefined,
      );
    } catch {
      setGeometrie(undefined);
      setAreaId(undefined);
      setStandortKoordinate(undefined);
    } finally {
      setLoading(false);
    }
  }, [projectId]);

  useEffect(() => {
    if (!projectId) {
      setLoading(false);
      return;
    }
    load();
  }, [projectId, load]);

  return { geometrie, areaId, standortKoordinate, loading, reload: load };
}
